import React from 'react';
import { DonutChart } from '@tremor/react';

const COLORS = { preAdvised: '#22c55e', nonAdvised: '#ef4444' };

const MovementPreadvisedPieChart = ({ preAdvised = 0, nonAdvised = 0, title }) => {
    const total = preAdvised + nonAdvised;
    if (total === 0) return null;

    const data = [
        { name: 'Pre-Advised', value: preAdvised, color: COLORS.preAdvised },
        { name: 'Non-Advised', value: nonAdvised, color: COLORS.nonAdvised },
    ];

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {title && (
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '8px', width: '100%', textAlign: 'center' }}>
                    {title}
                </div>
            )}
            <DonutChart
                data={data.map(({ name, value }) => ({ name, value }))}
                index="name"
                category="value"
                variant="pie"
                valueFormatter={(v) => `${v} (${total ? Math.round((v / total) * 100) : 0}%)`}
                colors={['green', 'red']}
                showAnimation={true}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '12px', alignItems: 'center' }}>
                {data.map(({ name, value, color }) => (
                    <div key={name} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#374151' }}>
                        <span
                            style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '2px',
                                backgroundColor: color,
                            }}
                        />
                        <span>{name}: {value} ({total ? Math.round((value / total) * 100) : 0}%)</span>
                    </div>
                ))}
                <div style={{ marginTop: '4px', paddingTop: '8px', borderTop: '1px solid #e5e7eb', fontSize: '13px', fontWeight: 600, color: '#1f2937' }}>
                    Total: {total}
                </div>
            </div>
        </div>
    );
};

export default MovementPreadvisedPieChart;
